import LayoutConfigTypes from '@/core/config/LayoutConfigTypes';

const config: LayoutConfigTypes = {
  themeName: 'Metronic',
  themeVersion: '8.0.37',
  demo: 'demo1',
  main: {
    type: 'default',
    primaryColor: '#009EF7',
    logo: {
      dark: '/media/logos/estilam-logo.png',
      light: '/media/logos/estilam-logo.png',
    },
  },
  illustrations: {
    set: 'sketchy-1',
  },
  loader: {
    logo: '/media/logos/estilam-logo.png',
    display: true,
    type: 'default',
  },
  scrollTop: {
    display: true,
  },
  header: {
    display: false,
    menuIcon: 'font',
    width: 'fluid',
    fixed: {
      desktop: true,
      tabletAndMobile: true,
    },
  },
  toolbar: {
    display: true,
    width: 'fluid',
    fixed: {
      desktop: true,
      tabletAndMobile: true,
    },
  },
  aside: {
    display: true,
    theme: 'dark',
    fixed: true,
    menuIcon: 'svg',
    minimized: false,
    minimize: true,
    hoverable: true,
  },
  content: {
    width: 'fluid',
  },
  footer: {
    width: 'fluid',
  },
};

export default config;
